import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {useLocation} from 'react-router-dom';

import {
  changeLayout,
  changeTopbarTheme,
  changeLayoutWidth,
} from '../../store/actions';

import Navbar from './Navbar';
import Header from './Header';
import Footer from './Footer';
import Rightbar from '../CommonForBoth/Rightbar';

const Layout = ({
  children,
  isPreloader,
  topbarTheme,
  layoutWidth,
  showRightSidebar,
  changeLayout,
  changeTopbarTheme,
  changeLayoutWidth,
}) => {
  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const location = useLocation();

  // ComponentDidMount equivalent
  useEffect(() => {
    if (isPreloader) {
      const preloader = document.getElementById('preloader');
      const status = document.getElementById('status');
      preloader.style.display = 'block';
      status.style.display = 'block';

      const timer = setTimeout(() => {
        preloader.style.display = 'none';
        status.style.display = 'none';
      }, 2500);

      return () => clearTimeout(timer);
    } else {
      document.getElementById('preloader').style.display = 'none';
      document.getElementById('status').style.display = 'none';
    }

    // Scroll to top
    window.scrollTo(0, 0);

    const title = location.pathname;
    const currentPage = title.charAt(1).toUpperCase() + title.slice(2);
    document.title = `${currentPage} | Brother TECNET | IPM Dealer Service Platform`;

    changeLayout('horizontal');
    topbarTheme && changeTopbarTheme(topbarTheme);
    layoutWidth && changeLayoutWidth(layoutWidth);
  }, [isPreloader, location.pathname, topbarTheme, layoutWidth, changeLayout, changeTopbarTheme, changeLayoutWidth]);

  const openMenu = () => {
    setIsMenuOpened((prev) => !prev);
  };

  return (
    <>
      <div id="preloader">
        <div id="status">
          <div className="spinner-chase">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="chase-dot"></div>
            ))}
          </div>
        </div>
      </div>

      <div id="layout-wrapper">
        <Header
          theme={topbarTheme}
          isMenuOpened={isMenuOpened}
          openLeftMenuCallBack={openMenu}
        />
        <Navbar menuOpen={isMenuOpened} />
        <div className="main-content">{children}</div>
        <Footer />
      </div>

      {showRightSidebar && <Rightbar />}
    </>
  );
};

const mapStateToProps = (state) => ({
  ...state.Layout,
});

export default connect(mapStateToProps, {
  changeTopbarTheme,
  changeLayout,
  changeLayoutWidth,
})(Layout);
